import {
  CREATE_BACKGROUND_PLACEHOLDER,
  LOAD_BACKGROUND_PLACEHOLDERS_BY_BOOK_ID } from './../../action-types/entities/backgroundPlaceholders';
import { generateId } from '../../helpers/index';

export const STATE_KEY = 'backgroundPlaceholders';

export const backgroundPlaceholders = (state = {
  byId: {},
  allIds: [],
}, action) => {
  switch (action.type) {
    case CREATE_BACKGROUND_PLACEHOLDER: {
      const { backgroundPlaceholder } = action;
      backgroundPlaceholder.id = generateId(state.allIds);
      return {
        byId: {
          ...state.byId,
          [backgroundPlaceholder.id]: backgroundPlaceholder,
        },
        allIds: [...state.allIds, backgroundPlaceholder.id],
      };
    }
    case LOAD_BACKGROUND_PLACEHOLDERS_BY_BOOK_ID: {
      return action.bookState;
    }
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/redux/reducers/entities/backgroundPlaceholders.js